import { extendObservable } from 'mobx';

class StreamModel {
    constructor(session) {
        this._session = session;

        extendObservable(this, {
            //Name
            streamname: '',
            //Input
            inputsource: '',
            inputlevel: '',
            inputchannel: '',
            samplingrate: '',
            //Encoder
            encodertype: '',
            bitratetype: '',
            bitrate: '',
            //Destination
            servertype: '',
            url: '',
            audioport: '',
            icyurl: '',
            mountpoint: '',
            remoteurl: '',
            username: '',
            password: '',
            streamurl: '',
            servertypeselect: '',
            icecastname: '',
            icecastdescription: '',
            icecastgenre: '',
            errorNetwork: false
        });
    }

    async load() {
        console.log('StreamModel: start');
        try {
            const jsonSession = await this._session.getJsonStream();

            if (jsonSession === 500) {
                Object.assign(this, { errorNetwork: true });
            } else if (jsonSession[0]) {
                const jsonInput = jsonSession[0][0];

                //Stream name modal

                let channelname = '';

                if (jsonInput.channel_name) {
                    channelname = jsonInput.channel_name;
                }

                //Stream input modal

                let inputsourceSettings = '',
                    inputlevelSettings = 'nominal',
                    inputchannelSettings = '',
                    samplingrateSettings = '';

                if (jsonInput.input_source) {
                    inputsourceSettings = jsonInput.input_source;
                }

                if (jsonInput.input_type !== '') {
                    inputlevelSettings = jsonInput.input_type;
                }

                if (jsonInput.input_channel) {
                    inputchannelSettings = jsonInput.input_channel;
                }

                if (jsonInput.sampling_rate) {
                    samplingrateSettings = jsonInput.sampling_rate;
                }

                //Stream encoder modal

                const jsonEncoder = jsonSession[0][1];

                let encodertypeSettings = '',
                    bitrt = '',
                    bitratetypeSettings = '';

                if (jsonEncoder.type) {
                    encodertypeSettings = jsonEncoder.type;
                }

                if (jsonEncoder.bit_rate_type) {
                    bitratetypeSettings = jsonEncoder.bit_rate_type;
                }

                if (jsonEncoder.bit_rate) {
                    bitrt = jsonEncoder.bit_rate;
                }

                //Stream destination modal

                let audioSettings = 0,
                    urldest = '',
                    icygenreSetting = '',
                    icynameSetting = '',
                    icydescriptionSetting = '',
                    usernameSetting = '',
                    passwordSetting = '',
                    servertypeselectSetting = '',
                    streamurlSetting = '';

                const jsonDestinations = jsonSession[0][2];
                const icyurlSetting = jsonDestinations.icy_url;
                const mountpointSetting = jsonDestinations.mount_point;
                const remoteurlsplit = jsonDestinations.remote_url.split('://');
                const remoteurlSetting = remoteurlsplit[1];

                if (jsonDestinations.port) {
                    audioSettings = jsonDestinations.port;
                }

                if (jsonDestinations.icy_genre) {
                    icygenreSetting = jsonDestinations.icy_genre;
                }

                if (jsonDestinations.icy_name) {
                    icynameSetting = jsonDestinations.icy_name;
                }

                if (jsonDestinations.icy_description) {
                    icydescriptionSetting = jsonDestinations.icy_description;
                }

                if (jsonDestinations.user_name) {
                    usernameSetting = jsonDestinations.user_name;
                }
                if (jsonDestinations.password) {
                    passwordSetting = jsonDestinations.password;
                }

                if (remoteurlSetting === '127.0.0.1') {
                    const settingsnetwork = await this._session.rpc('call', [
                        '',
                        'network',
                        'status',
                        {}
                    ]);
                    streamurlSetting =
                        'http://' +
                        settingsnetwork[1]['ipv4-address'][0] +
                        ':' +
                        audioSettings +
                        '/' +
                        mountpointSetting;
                } else {
                    streamurlSetting =
                        'http://' +
                        remoteurlSetting +
                        ':' +
                        audioSettings +
                        '/' +
                        mountpointSetting;
                }

                if (remoteurlSetting === '127.0.0.1') {
                    servertypeselectSetting = 'server';
                } else if (remoteurlSetting === '') {
                    servertypeselectSetting = '';
                } else {
                    servertypeselectSetting = 'source';
                }

                const loadobj = {
                    headername: 'Set Stream Name',
                    headerinput: 'Set Input Values',
                    headerencoder: 'Set Encoder Values',
                    headerdestination: 'Set Stream Destination',
                    streamname: channelname,
                    inputsource: inputsourceSettings,
                    inputlevel: inputlevelSettings,
                    inputchannel: inputchannelSettings,
                    samplingrate: samplingrateSettings,
                    encodertype: encodertypeSettings,
                    bitratetype: bitratetypeSettings,
                    bitrate: bitrt,
                    servertype: 'Icecast',
                    url: urldest,
                    audioport: audioSettings,
                    icyurl: icyurlSetting,
                    mountpoint: mountpointSetting,
                    remoteurl: remoteurlSetting,
                    username: usernameSetting,
                    password: passwordSetting,
                    streamurl: streamurlSetting,
                    servertypeselect: servertypeselectSetting,
                    icecastname: icynameSetting,
                    icecastdescription: icydescriptionSetting,
                    icecastgenre: icygenreSetting,
                    errorNetwork: false
                };
                Object.assign(this, loadobj);
            } else {
                const loadobj = {
                    headername: 'Set Stream Name',
                    headerinput: 'Set Input Values',
                    headerencoder: 'Set Encoder Values',
                    headerdestination: 'Set Stream Destination',
                    streamname: '',
                    inputsource: '',
                    inputlevel: 'nominal',
                    inputchannel: '',
                    samplingrate: '',
                    encodertype: '',
                    bitratetype: '',
                    bitrate: '',
                    servertype: 'Icecast',
                    url: '',
                    audioport: 0,
                    icyurl: '',
                    mountpoint: '',
                    remoteurl: '',
                    username: '',
                    password: '',
                    streamurl: '',
                    servertypeselect: '',
                    icecastname: '',
                    icecastdescription: '',
                    icecastgenre: '',
                    errorNetwork: false
                };
                Object.assign(this, loadobj);
            }
        } catch (err) {
            console.error('StreamModel:' + err);
        }
        console.log('StreamModel: end');
    }

    validate(name) {
        if (name === 'streamname') {
            /* if (/^[a-zA-Z0-9-_ ]*$/.test(this.streamname) === false) {
                return 'No special characters allowed';
            } else */ if (
                this.streamname === ''
            ) {
                return 'Stream name cannot be empty';
            } else {
                return true;
            }
        } else if (name === 'inputchannel') {
            if (this.inputchannel === '') {
                return 'Input channel cannot be empty';
            } else {
                return true;
            }
        } else if (name === 'inputsource') {
            if (this.inputsource === '') {
                return 'Input Source cannot be empty';
            } else {
                return true;
            }
        } else if (name === 'samplingrate') {
            if (this.samplingrate === '') {
                return 'Sampling rate cannot be empty';
            } else {
                return true;
            }
        } else if (name === 'encodertype') {
            if (this.encodertype === '') {
                return 'Encoder type cannot be empty';
            } else {
                return true;
            }
        } else if (name === 'bitratetype') {
            if (this.bitratetype === '') {
                return 'Bitrate type cannot be empty';
            } else {
                return true;
            }
        } else if (name === 'bitrate') {
            if (this.bitrate === '') {
                return 'Bitrate cannot be empty';
            } else {
                return true;
            }
            // } else if (name === 'audioquality') {
            //     if (this.audioquality === '') {
            //         return 'Audio quality cannot be empty';
            //     } else {
            //         return true;
            //     }
        } else if (name === 'servertype') {
            if (this.servertype === '') {
                return 'Server type cannot be empty';
            } else {
                return true;
            }
        } else if (name === 'audioport') {
            if (
                this.audioport < 0 ||
                this.audioport === '' ||
                this.audioport > 65535
            ) {
                return 'The audioport must be between 0 and 65535';
            } else {
                return true;
            }
        } else if (name === 'url') {
            if (
                /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                    this.url
                )
            ) {
                return true;
            } else {
                return 'The url consists of four decimal numbers, each ranging from 0 to 255, separated by dots';
            }
        } else if (name === 'icyurl') {
            if (
                /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                    this.icyurl
                )
            ) {
                return true;
            } else {
                return 'The url consists of four decimal numbers, each ranging from 0 to 255, separated by dots';
            }
        } else if (name === 'remoteurl') {
            /*if (
                /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                    this.remoteurl
                )
            )*/

            if (
                /((https?:\/\/)|(HTTPS?:\/\/))?((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|((([a-zA-Z0-9]+\.)*)([a-zA-Z0-9]+)((\/[a-zA-Z0-9]+)*)))/.test(
                    this.remoteurl
                )
            ){
                return true;
            } else {
                return 'The url consists of four decimal numbers, each ranging from 0 to 255, separated by dots (Ex: ###.###.###.###)';
            }
            //console.log("Remote URL is always valid");
            //return true;
        } else if (name === 'password') {
            if (
                !this.password ||
                (this.password &&
                    (this.password.length === '' ||
                        this.password.length > 32 ||
                        this.password.length === 0))
            ) {
                return 'The password should have between 1 and 32 characters';
            } else {
                /*else if (/^[a-zA-Z0-9-_ ]*$/.test(this.password) === false) {
                return 'No special characters allowed';
            } */
                return true;
            }
        } else if (name === 'username') {
            if (!this.username || this.username === '') {
                return 'The username cannot be empty';
            } else {
                /*
            else if (/^[a-zA-Z0-9-_ ]*$/.test(this.username) === false) {
                return 'No special characters allowed';
            }
            */
                return true;
            }
        } else if (name === 'mountpoint') {
            if (this.mountpoint.length > 32 || this.mountpoint === '') {
                return 'The mount point should have between 1 and 32 characters';
            } else {
                return true;
            }
        } else if (name === 'icecastname') {
            if (
                !this.icecastname ||
                (this.icecastname.length > 32 || this.icecastname === '')
            ) {
                return 'The icecast name should have between 1 and 32 characters';
            } else {
                return true;
            }
        } else if (name === 'icecastdescription') {
            if (
                !this.icecastdescription ||
                (this.icecastdescription.length > 32 ||
                    this.icecastdescription === '')
            ) {
                return 'The icecast description should have between 1 and 32 characters';
            } else {
                return true;
            }
        } else if (name === 'icecastgenre') {
            if (
                !this.icecastgenre ||
                (this.icecastgenre.length > 32 || this.icecastgenre === '')
            ) {
                return 'The icecast genre should have between 1 and 32 characters';
            } else {
                return true;
            }
        } else if (name === 'servertypeselect') {
            if (this.servertypeselect === '') {
                return 'The server type cannot be empty';
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    async validateModelByModal(modal) {
        let invalidFields = [];

        if (modal === 'name') {
            if (
                /^[a-zA-Z0-9-_ ]*$/.test(this.streamname) === false ||
                this.streamname === ''
            ) {
                invalidFields.push('streamname');
            }
        } else if (modal === 'input') {
            if (this.inputsource === '') {
                invalidFields.push('inputsource');
            }

            if (this.inputchannel === '') {
                invalidFields.push('inputchannel');
            }

            if (this.samplingrate === '') {
                invalidFields.push('samplingrate');
            }
        } else if (modal === 'encoder') {
            if (this.encodertype === '') {
                invalidFields.push('encodertype');
            } else {
                if (this.encodertype === 'mp3') {
                    if (this.bitratetype === '') {
                        invalidFields.push('bitratetype');
                    }
                }
                if (this.bitrate === '') {
                    invalidFields.push('bitrate');
                }
            }
            // if (this.encodertype === 'mp3') {
            //     if (this.audioquality === '') {
            //         invalidFields.push('audioquality');
            //     }
            // }
            // if (this.encodertype === 'aac') {
            //     if (this.bitrate === '') {
            //         invalidFields.push('bitrate');
            //     }
            // }
        } else if (modal === 'destination') {
            if (this.servertypeselect === '') {
                invalidFields.push('servertypeselect');
            } else {
                if (this.servertypeselect === 'server') {
                    if (this.mountpoint.length > 32 || this.mountpoint === '') {
                        invalidFields.push('mountpoint');
                    }

                    this.audioport = 8000;
                    this.remoteurl = '127.0.0.1';
                    this.username = 'source';
                    this.password = 'barix_icecast';
                } else {
                    if (
                        this.audioport < 0 ||
                        this.audioport === '' ||
                        this.audioport > 65535
                    ) {
                        invalidFields.push('audioport');
                    }
                    //it can accept an IP address or
                    /*if (
                        !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                            this.remoteurl

                        )
                    )*/
                    if (
                        !/((https?:\/\/)|(HTTPS?:\/\/))?((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|((([a-zA-Z0-9]+\.)*)([a-zA-Z0-9]+)((\/[a-zA-Z0-9]+)*)))/.test(
                            this.remoteurl
                        )
                    ) {
                        invalidFields.push('remoteurl');
                    }

                    console.log("Remote URL is always valid");

                    if (
                        !this.password ||
                        (this.password &&
                            (this.password.length === '' ||
                                this.password.length > 32 ||
                                this.password.length === 0 ||
                                /^[a-zA-Z0-9-_ ]*$/.test(this.password) ===
                                    false))
                    ) {
                        invalidFields.push('password');
                    }

                    if (
                        !this.username ||
                        this.username === '' ||
                        /^[a-zA-Z0-9-_ ]*$/.test(this.username) === false
                    ) {
                        invalidFields.push('username');
                    }
                }
            }

            if (
                this.icecastgenre.length > 32 ||
                this.icecastgenre.length === 0
            ) {
                invalidFields.push('icecastgenre');
            }

            if (this.icecastname.length > 32 || this.icecastname.length === 0) {
                invalidFields.push('icecastname');
            }

            if (
                this.icecastdescription.length > 32 ||
                this.icecastdescription.length === 0
            ) {
                invalidFields.push('icecastdescription');
            }
        }

        return invalidFields;
    }

    async validateAllModel() {
        let invalidFields = [];

        if (
            /^[a-zA-Z0-9-_ ]*$/.test(this.streamname) === false ||
            this.streamname === ''
        ) {
            invalidFields.push('streamname');
        }

        if (this.inputsource === '') {
            invalidFields.push('inputsource');
        }

        if (this.inputchannel === '') {
            invalidFields.push('inputchannel');
        }

        if (this.samplingrate === '') {
            invalidFields.push('samplingrate');
        }

        if (this.encodertype === '') {
            invalidFields.push('encodertype');
        } else {
            if (this.encodertype === 'mp3') {
                if (this.bitratetype === '') {
                    invalidFields.push('bitratetype');
                }
            }

            if (this.bitrate === '') {
                invalidFields.push('bitrate');
            }
        }
        // if (this.encodertype === 'mp3') {
        //     if (this.audioquality === '') {
        //         invalidFields.push('audioquality');
        //     }
        // }
        // if (this.encodertype === 'aac') {
        //     if (this.bitrate === '') {
        //         invalidFields.push('bitrate');
        //     }
        // }

        if (this.servertypeselect === '') {
            invalidFields.push('servertypeselect');
        } else {
            if (this.servertypeselect === 'server') {
                if (this.mountpoint.length > 32 || this.mountpoint === '') {
                    invalidFields.push('mountpoint');
                }

                this.audioport = 8000;
                this.remoteurl = '127.0.0.1';
                this.username = 'source';
                this.password = 'barix_icecast';
            } else {
                if (
                    this.audioport < 0 ||
                    this.audioport === '' ||
                    this.audioport > 65535
                ) {
                    invalidFields.push('audioport');
                }

                console.log("Remote URL is always valid")
                /*if (
                    !/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
                        this.remoteurl
                    )
                )*/
                if (
                    !/((https?:\/\/)|(HTTPS?:\/\/))?((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)|((([a-zA-Z0-9]+\.)*)([a-zA-Z0-9]+)((\/[a-zA-Z0-9]+)*)))/.test(
                        this.remoteurl
                    )
                ) {
                    invalidFields.push('remoteurl');
                }

                if (
                    !this.password ||
                    (this.password &&
                        (this.password.length === '' ||
                            this.password.length > 32 ||
                            this.password.length === 0 ||
                            /^[a-zA-Z0-9-_ ]*$/.test(this.password) === false))
                ) {
                    invalidFields.push('password');
                }

                if (
                    !this.username ||
                    this.username === '' ||
                    /^[a-zA-Z0-9-_ ]*$/.test(this.username) === false
                ) {
                    invalidFields.push('username');
                }
            }
        }

        if (
            !this.icecastgenre ||
            ((this.icecastgenre && this.icecastgenre.length > 32) ||
                this.icecastgenre.length === 0)
        ) {
            invalidFields.push('icecastgenre');
        }

        if (
            !this.icecastname ||
            (this.icecastname.length > 32 || this.icecastname.length === 0)
        ) {
            invalidFields.push('icecastname');
        }

        if (
            !this.icecastdescription ||
            (this.icecastdescription.length > 32 ||
                this.icecastdescription.length === 0)
        ) {
            invalidFields.push('icecastdescription');
        }

        return invalidFields;
    }
}

export default StreamModel;



// WEBPACK FOOTER //
// ./src/models/StreamModel.js